import React from 'react'
import classNames from 'classnames'

import DropdownMenu from './dropdownMenu'

import css from './dropdownMenuGroup.scss'

class DropdownMenuGroup extends React.Component {
  render() {
    const {
      HeaderComponent,
      className,
      history,
      fullWidthItemsInSmallScreen,
      displayIcon,
      IconElement,
      popupHorizontalPosition,
      addSeparatorForSubmenu,
    } = this.props
    const containerClasses = classNames(className, css.container)

    return (
      <div className={containerClasses}>
        {this.props.menu.map((headerItem, index) => (
          <DropdownMenu
            key={index}
            item={headerItem}
            HeaderComponent={HeaderComponent}
            displayIcon={displayIcon}
            IconElement={IconElement}
            hasArrow
            history={history}
            fullWidthItemsInSmallScreen={fullWidthItemsInSmallScreen}
            menuClassName={headerItem.menuClassName}
            popupHorizontalPosition={popupHorizontalPosition}
            addSeparatorForSubmenu={addSeparatorForSubmenu}
          />
        ))}
      </div>
    )
  }
}

export default DropdownMenuGroup
